<template>
  <v-menu content-class="overflow-visible" nudge-right="64" max-width="256" :close-on-content-click="false">
    <template v-slot:activator="{ on }">
      <slot v-bind="{ on }" />
    </template>
    <div class="white" @click.stop>

      <div class="d-flex flex-wrap btn-group overflow-hidden">
        <v-btn
          v-for="frame in BASIC_FRAMES" :key="frame"
          style="width: 64px; height: 64px; border-radius: unset;"
          class="pa-0 overflow-hidden white"
          :input-value="options.frame == frame"
          @click="$set(options, 'frame', options.frame == frame ? null : frame)"
        >
          <blob-frame
            style="position: relative !important; transform: scale(.5); transform-origin: bottom right; width: 120px; height: 120px;"
            :frame="frame"
          >
            <div v-if="showBackground" class="ec-blue" style="width: 100%; height: 100%;" />
          </blob-frame>
        </v-btn>
      </div>

      <v-divider />

      <div class="d-flex justify-center pa-3">
        <div class="btn-group">
          <v-btn
            v-blur
            class="btn-group-right"
            @click="setFrameOption('tail', BUBBLE_FRAME_TAILS[ (frameOptionsTailI + 1) % 4 ])"
          >
            <v-icon
              v-bind:style="{ transform: `rotate(${90 * frameOptionsTailI}deg)` }"
              v-html="mdiArrowBottomLeftThick"
            />
            <span class="btn-tooltip top">Tail position</span>
          </v-btn>
          <color-picker-btn
            :colors="[ ...COLORS, null ]"
            :value="frameOptions.stroke"
            @input="v => setFrameOption('stroke', v)"
          >
            <template v-slot="{ on }">
              <v-btn v-on="on" v-blur class="btn-group-left btn-group-right">
                <v-icon
                  v-bind:style="{ filter: frameOptions.stroke ? 'drop-shadow(0 0 1px #0003)' : null }"
                  :color="frameOptions.stroke"
                  v-html="frameOptions.stroke ? mdiCircleOutline : mdiCircleOffOutline"
                />
                <span class="btn-tooltip top">Outline color</span>
              </v-btn>
            </template>
          </color-picker-btn>
          <color-picker-btn :colors="COLORS" :value="frameOptions.fill" @input="v => setFrameOption('fill', v)">
            <template v-slot="{ on }">
              <v-btn v-on="on" v-blur class="btn-group-left btn-group-right">
                <v-icon style="filter: drop-shadow(0 0 1px #0003);" :color="frameOptions.fill" v-html="mdiCircle" />
                <span class="btn-tooltip top">Fill color</span>
              </v-btn>
            </template>
          </color-picker-btn>
          <v-menu offset-x nudge-right="4" min-width="224" :close-on-content-click="false">
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" v-blur class="btn-group-left">
                <v-icon v-html="mdiBoxShadow" />
                <span class="btn-tooltip top">Shadow</span>
              </v-btn>
            </template>
            <div class="white d-flex align-center relative" @click.stop>
              <v-slider
                class="ma-3"
                hide-details min="0" max="100" step="5"
                :value="frameOptions.shadow * 10"
                @input="v => setFrameOption('shadow', parseFloat(v / 10))"
              />
            </div>
          </v-menu>
        </div>
      </div>

      <div class="d-flex flex-wrap btn-group">
        <v-btn
          v-for="{ key: frame } in BUBBLE_FRAMES" :key="frame"
          style="width: 128px; height: 128px; border-radius: unset;"
          class="pa-3 white"
          elevation="0"
          :input-value="options.frame == frame"
          @click="
            () => {
              if (options.frame == frame) {
                $set(options, 'frame', null);
              } else {
                if (!options.frame_options)
                  $set(options, 'frame_options', { ...frameOptions });
                $set(options, 'frame', frame);
              }
            }
          "
        >
          <blob-frame
            style="position: relative !important; width: 104px; height: 104px;"
            :frame="frame"
            :options="{ ...frameOptions, shadow: (!frameOptions.shadow && (!frameOptions.outline || (frameOptions.outline == '#FEFEFE')) && (frameOptions.fill == '#FEFEFE')) ? .5 : frameOptions.shadow }"
          />
        </v-btn>
      </div>

    </div>
  </v-menu>
</template>

<script>
import BlobFrame from '@/components/BlobFrame.vue';
import ColorPickerBtn from '@/components/ColorPickerBtn.vue';
import { colors as COLORS, frames as BASIC_FRAMES } from '@/card-customization-options.js';
import { BUBBLE_FRAME_TAILS, BUBBLE_FRAMES } from '@/utils/bubble-frames.js';
import { getRandomContrastingColor } from '@/utils/group-video-template.js';
import { mdiArrowBottomLeftThick, mdiCircle, mdiCircleOutline, mdiCircleOffOutline, mdiBoxShadow } from '@mdi/js';


const DEFAULT_FRAME_OPTIONS = {
  tail: 'bottom-left',
  stroke: '#000000',
  fill: '#FEFEFE',
  shadow: 3
};


export default {
  name: 'frame-btn',

  components: {
    BlobFrame,
    ColorPickerBtn
  },

  props: [ 'options', 'showBackground' ],

  computed: {
    frameOptionsDefaults() {
      if (this.options.color) {
        const fill = getRandomContrastingColor(this.options.color, COLORS);
        const stroke = getRandomContrastingColor(fill, COLORS);
        return { ...DEFAULT_FRAME_OPTIONS, stroke, fill };
      }
      return DEFAULT_FRAME_OPTIONS;
    },

    frameOptions() {
      return BUBBLE_FRAMES.map(x => x.key).includes(this.options.frame) && this.options.frame_options || this.frameOptionsDefaults;
    },

    frameOptionsTailI() {
      return BUBBLE_FRAME_TAILS.indexOf(this.frameOptions.tail);
    }
  },

  created() {
    Object.assign(this, { COLORS, BASIC_FRAMES, BUBBLE_FRAME_TAILS, BUBBLE_FRAMES, mdiArrowBottomLeftThick, mdiCircle, mdiCircleOutline, mdiCircleOffOutline, mdiBoxShadow });
  },

  methods: {
    setFrameOption(key, value) {
      this.$set(this.options, 'frame_options', Object.assign({}, this.frameOptions, { [key]: value }));
    }
  }
}
</script>
